import { mmoSyncSchemaMap } from "@game/config";
import { createMMOServerConnection } from "@services/mmo-game-client/createMMOServerConnection";
import { GameAuth, GameAuthType, MMONetSchema } from "mmo-common";
import { RealmsEngineClient } from "realms-engine-network-client";
import { GAME_FPS } from "../../configs";
import { vector2FromAngle } from "realms-engine";

export class StressTestService {
  /**
   * Make N Player connections to the server
   */
  async stressTest({
    token,
    playerCount,
  }: {
    token: string;
    playerCount: number;
  }) {
    const clients: {
      client: RealmsEngineClient<MMONetSchema>;
      cleanUp: () => void;
    }[] = [];
    for (let i = 0; i < playerCount; i++) {
      const client = new RealmsEngineClient<MMONetSchema>(
        createMMOServerConnection(),
        mmoSyncSchemaMap,
        {
          ping: false,
        }
      );
      const auth: GameAuth = {
        authType: GameAuthType.StressTesting,
        token,
      };
      await client.connect(auth);
      client
        .getConnection()
        .once("ServerForcedDisconnect", (message: string) =>
          console.log(message)
        );
      await new Promise((r) => client.getConnection().once("connect", r));

      const intervalId = setInterval(() => {
        if (client.isConnected()) {
          client.getConnection().emit("input", {
            move: vector2FromAngle(
              (2 * Math.PI * (Math.round(Date.now() / 1000) % 10)) / 10
            ),
            jump: Math.random() > 0.9,
          });
        }
      }, 1000 / GAME_FPS);
      const cleanUp = () => {
        clearInterval(intervalId);
      };
      clients.push({ client, cleanUp });
    }
    const disconnectAll = () => {
      clients.forEach((client) => {
        client.client.disconnect();
        client.cleanUp();
      });
    };
    return disconnectAll;
  }
}
